export default __webpack_public_path__ + "static/media/undraw_High_five.0b4aee88.svg";